export const ADDED = "ClientPayment_ADDED";
export const EDITED = "ClientPayment_EDITED";